export class VagasCatFuncPK {
  seqCargo: number = null;
  nr: number = null;

  constructor(d?) {
    if (d) {
      this.seqCargo = d.seqCargo ? d.seqCargo : null;
      this.nr = d.nr ? d.nr : null;
    }
  }
}
